<div class="backdrop-modal-mensagem"></div>

<div class="modal-mensagem">
  <div class="conteudo">
    <span class="icone-wrapper" [class]="tipo">
      <mat-icon class="icone" aria-hidden="true">{{ icone }}</mat-icon>
    </span>

    <h3 *ngIf="titulo">{{ titulo }}</h3>
    <p>{{ mensagem }}</p>

    <div class="acoes">
      <button
        type="button"
        class="btn-cancelar"
        *ngIf="exibirCancelar"
        (click)="onCancelar()"
      >
        {{ textoCancelar }}
      </button>
      <button
        type="button"
        class="btn-confirmar"
        [class]="tipo"
        [style.background]="corConfirmar || null"
        (click)="onConfirmar()"
      >
        {{ textoConfirmar }}
      </button>
    </div>
  </div>
</div>
